<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="esgProfil">
                <div class="row">
                  <div class="col-md-12">
                    <span class="pr-input-label ng-star-inserted"
                      >Dans votre investissement, vous souhaitez qu'au moins :
                    </span>
                  </div>
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="taxonomy"
                      direction="column"
                      [isDefault]="false"
                      columns="5"
                      [options]="taxonomyOptions"
                    >
                    </pr-input-radio>
                  </div>
                  <div class="col-md-12">
                    <span class="pr-input-label ng-star-inserted"
                      >soient alignés avec la « Taxonomie » environnementale .
                    </span>
                  </div>
                  <div class="col-md-12">
                    <info [option]="{ icon: 'info' }"
                      >C'est-à-dire avec l'un des 6 objectifs suivants, sans
                      nuire aux 5 autres : atténuation du changement climatique,
                      adaptation au changement climatique, utilisation durable
                      et protection des ressources aquatiques et marines,
                      transition vers une économie circulaire, prévention et
                      réduction de la pollution et protection et restauration de
                      la biodiversité et des écosystèmes.</info
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <span class="pr-input-label ng-star-inserted">et : </span>
                  </div>
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="sustainability"
                      direction="column"
                      [isDefault]="false"
                      columns="5"
                      [options]="sustainabilityOptions"
                    >
                    </pr-input-radio>
                  </div>
                  <div class="col-md-12">
                    <span class="pr-input-label ng-star-inserted"
                      >soient considérés comme « durable ».
                    </span>
                  </div>
                  <div class="col-md-12">
                    <info [option]="{ icon: 'info' }"
                      >Selon la réglementation « SFDR », c'est un investissement
                      dans une activité économique contribuant à un objectif
                      environnemental ou social sans causer de préjudice
                      significatif à d'autres objectifs environnementaux ou
                      sociaux, tout en veillant à ce que l'entreprise dans
                      laquelle est effectué l'investissement applique des bonnes
                      pratiques de gouvernance.</info
                    >
                  </div>
                  <!-- infoValue: "", -->
                </div>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
